import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, Subject, Subscription } from 'rxjs';
import {
  DeactivatedUsersCounters,
  PaginatableDeactivationIncidents,
  ReactivationPetitionStatus,
  DefaultService as RestApiService,
} from 'src/app/swagger-api';

@Injectable({
  providedIn: 'root',
})
export class DeactivatedUsersService {
  public deactivatedCounterChanges$: Subject<DeactivatedUsersCounters> = new Subject();

  private apiService = inject(RestApiService);

  public get counterChanges(): Observable<DeactivatedUsersCounters> {
    return this.deactivatedCounterChanges$.asObservable();
  }

  public get communitiesCounterChanges(): Observable<DeactivatedUsersCounters> {
    return this.deactivatedCounterChanges$.asObservable();
  }

  public fetchRequestCounters(): void {
    const subscription: Subscription = this.apiService
      .restAuthDeactivatedUsersCountersGet()
      .pipe(catchError(() => EMPTY))
      .subscribe((counters: DeactivatedUsersCounters) => {
        this.deactivatedCounterChanges$.next(counters);
        subscription.unsubscribe();
      });
  }

  public getDeactivationIncidents(
    reactivationPetitionStatus?: ReactivationPetitionStatus,
    offset?: number,
    limit?: number,
  ): Observable<PaginatableDeactivationIncidents> {
    return this.apiService.restAuthDeactivateIndex(reactivationPetitionStatus, offset, limit);
  }
}
